<template>
  <b-modal
    v-model="isVisible"
    centered
    hide-header
    hide-header-close
    hide-footer
    content-class="!rounded-[12px]"
    body-class="!p-[1.25rem]"
    @hidden="onHidden"
  >
    <h4 class="!text-base font-semibold mb-[1.25rem] text-[#0A0A0A]">
      {{ mode === 'add' ? 'Tambah Kategori' : 'Edit Kategori' }}
    </h4>

    <form @submit.prevent="submit">
      <ValidationObserver
        ref="formObserver"
        v-slot="{ invalid }"
      >
        <div class="mb-[1.75rem] py-[1.75rem]">
          <label class="text-[#0A0A0A] mb-[0.75rem] block font-medium">Nama Kategori <span class="text-[#DC2626]">*</span></label>
          <ValidationProvider
            v-slot="{ errors }"
            name="nama kategori"
            :rules="{
              required_trim: true,
              alphanumeric_space: true,
              no_leading_trailing_spaces: true,
              no_consecutive_spaces: true,
              min_max_length: { min: 3, max: 30 },
              unique_value: { validateFn: checkUniqueCategory }
            }"
          >
            <b-form-input
              v-model="namaKategori"
              placeholder="Masukkan nama kategori"
              class="!rounded-[8px] !shadow-[0px_1px_2px_0px_#0000001A] text-[#0A0A0A]"
              :class="[ errors.length > 0 ? 'border-[#DC2626]' : 'border-[#E5E5E5]' ]"
            />
            <small
              class="mt-[0.75rem] block text-[14px]"
              :class="[errors.length === 0 ? 'text-[#737373]' : 'text-[#DC2626]']"
            >{{ errors.length === 0 ? '3-30 karakter hanya berisi huruf & angka' : errors[0] }}</small>
          </ValidationProvider>
        </div>

        <div class="flex justify-end items-center mt-[1.25rem] gap-[0.5rem]">
          <b-button
            variant="ghost"
            size="sm"
            class="!text-[#737373] !font-normal !px-[1rem] !py-[0.25rem] !shadow-none !rounded-[8px]"
            :disabled="isLoading"
            @click="close"
          >
            Batal
          </b-button>
          <b-button
            type="submit"
            :variant="!invalid && namaKategori.length > 0 && !isLoading ? 'primary' : 'secondary'"
            class="!rounded-[8px] !px-[1rem] !py-[0.65rem] !flex items-center justify-center gap-[8px]"
            size="sm"
            :disabled="invalid || namaKategori.length === 0 || isLoading"
          >
            <b-spinner
              v-if="isLoading"
              small
            />
            <span>Simpan</span>
          </b-button>
        </div>
      </ValidationObserver>
    </form>
  </b-modal>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  requiredTrim,
  alphanumericSpace,
  minMaxLength,
  noLeadingTrailingSpaces,
  noConsecutiveSpaces,
  uniqueValue,
} from '@validations'

export default {
  name: 'CreateCategoryDialog',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isVisible: false,
      mode: 'add',
      initialValue: '',
      namaKategori: '',
      isLoading: false,
      onSubmitCallback: null,
    }
  },
  methods: {
    checkUniqueCategory(value) {
      const valToLower = String(value).toLowerCase().trim()
      const isDuplicate = this.data.some(c => {
        if (this.mode === 'edit' && String(c.name).toLowerCase().trim() === String(this.initialValue).toLowerCase().trim()) {
          return false
        }
        return String(c.name).toLowerCase().trim() === valToLower
      })
      return !isDuplicate
    },
    /**
     * Opens dialog with specific mode and data.
     * @param {Object} options - Dialog options (mode, initialValue, onSubmit).
     */
    show(options = {}) {
      this.mode = options.mode || 'add'
      this.initialValue = options.initialValue || ''
      this.namaKategori = this.initialValue
      this.onSubmitCallback = options.onSubmit || null
      this.isVisible = true

      this.$nextTick(() => {
        if (this.$refs.formObserver) {
          this.$refs.formObserver.reset()
        }
      })
    },
    /**
     * Resets form state when dialog hides.
     */
    onHidden() {
      this.namaKategori = ''
      if (this.$refs.formObserver) {
        this.$refs.formObserver.reset()
      }
    },
    /**
     * Hides the dialog.
     */
    close() {
      this.isVisible = false
    },
    /**
     * Validates and submits form data.
     */
    submit() {
      this.$refs.formObserver.validate().then(async success => {
        if (success && typeof this.onSubmitCallback === 'function') {
          try {
            this.isLoading = true
            await this.onSubmitCallback(this.namaKategori)
            this.$toast_success({ message: this.mode === 'add' ? 'Kategori berhasil ditambahkan' : 'Kategori berhasil diupdate' })
            this.close()
          } catch (error) {
            this.$toast_error({ message: error?.response?.data?.meta?.message || `Gagal ${this.mode === 'add' ? 'membuat' : 'mengupdate'} kategori, silahkan coba lagi` })
          } finally {
            this.isLoading = false
          }
        }
      })
    },
  },
}
</script>
